import { ColoursObj, Icon, Typography } from "@eventr/common-storybook";
import { MarkdownRow } from "home/components/summary/markdownRow";
import { cardTranslation } from "i18n/translateHelpers";
import { RowInfo } from "./rowInfo";
import { CardText } from "./cardText";

interface IRowInfoBaggageProps {
  baggage: string;
  type?: "card" | "page";
}
export const RowInfoBaggage = ({ baggage, type }: IRowInfoBaggageProps) => {
  if (!baggage) return null;
  if (type === "page") {
    return (
      <RowInfo
        start={<Icon name="Suitcase" iconColour={ColoursObj.core.secondary} />}
        under={<MarkdownRow value={baggage} />}
        middle={<Typography variant="bodyBold">{cardTranslation("Additional Information")}</Typography>}
      />
    );
  }
  return (
    <RowInfo
      start={<Icon name="Suitcase" bubble bubbleColour={ColoursObj.coreBrights.secondary} />}
      middle={<CardText useMarkdown>{baggage}</CardText>}
    />
  );
};
